import { render } from "./ScientistNotesAndTeachingTips.vue?vue&type=template&id=6f9f241a"
import script from "./ScientistNotesAndTeachingTips.vue?vue&type=script&lang=js"
export * from "./ScientistNotesAndTeachingTips.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__